import { render, staticRenderFns } from "./versionStatistics.vue?vue&type=template&id=4704c760&scoped=true&"
import script from "./versionStatistics.vue?vue&type=script&lang=js&"
export * from "./versionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./versionStatistics.vue?vue&type=style&index=0&id=4704c760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704c760",
  null
  
)

export default component.exports